import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a passenger-car icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <PassengerCarIcon width={48} />
 */
const PassengerCarIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M21,12v2v3v2c0,0.55-0.45,1-1,1h-1c-0.55,0-1-0.45-1-1v-1H6v1c0,0.55-0.45,1-1,1H4c-0.55,0-1-0.45-1-1v-2v-3v-2
                c0-0.55,0.32-1.32,0.71-1.71l0.59-0.59c0.39-0.39,0.87-1.12,1.08-1.64l1.26-3.14C6.83,4.42,7.45,4,8,4h8c0.55,0,1.17,0.42,1.37,0.93
                l1.26,3.14c0.2,0.51,0.69,1.25,1.08,1.64l0.59,0.59C20.68,10.68,21,11.45,21,12z M5.5,12C4.67,12,4,12.67,4,13.5S4.67,15,5.5,15
                S7,14.33,7,13.5S6.33,12,5.5,12z M18.5,12c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S19.33,12,18.5,12z M8.5,5.5
                c-0.27,0-0.59,0.21-0.7,0.46L6.2,9.54C6.09,9.79,6.22,10,6.5,10h11c0.27,0,0.41-0.21,0.3-0.46L16.2,5.96
                c-0.11-0.25-0.43-0.46-0.7-0.46H8.5z M10,16h4c0.55,0,1-0.45,1-1H9C9,15.55,9.45,16,10,16z`}
        />
    </SvgIcon>
)

PassengerCarIcon.defaultProps = defaultProps

export { PassengerCarIcon }
